import { createRoute, redirect } from '@tanstack/react-router';

import { menuLayoutRoute } from 'root/MenuLayout';

import { clawbackDetailRoute } from './ClawbackDetailView';
import { clawbackListRoute } from './ClawbackListView';
import { grirDetailRoute } from './GrirDetailView';
import { grirListRoute } from './GrirListView';
import { inventoryInvoicesRoute } from './InventoryInvoicesView';
import { invoiceDetailsRoute } from './InvoiceDetailsView';
import { invoicesSettingsRoute } from './InvoiceSettingsView';
import { ListViewWrapper } from './ListViewWrapper';
import { nonInventoryInvoicesRoute } from './NonInventoryInvoicesView';
import { tasksIndexRoute, tasksListRoute } from './TasksListView';

export { invoicesLegacyRedirectRouteTree } from './invoicesLegacyRedirects';

const financeMainRoute = createRoute({
  getParentRoute: () => menuLayoutRoute,
  path: 'finance',
});

export const invoicesMainRoute = createRoute({
  getParentRoute: () => financeMainRoute,
  path: 'invoices',
});

export const invoicesListLayoutRoute = createRoute({
  getParentRoute: () => invoicesMainRoute,
  id: 'invoices-list-layout',
  component: ListViewWrapper,
});

const nonInventoryInvoicesMainRoute = createRoute({
  getParentRoute: () => financeMainRoute,
  path: 'non-inventory-invoices',
});

export const nonInventoryListLayoutRoute = createRoute({
  getParentRoute: () => nonInventoryInvoicesMainRoute,
  id: 'non-inventory-list-layout',
  component: ListViewWrapper,
});

export const grirMainRoute = createRoute({
  getParentRoute: () => financeMainRoute,
  path: 'grir',
});

export const grirListLayoutRoute = createRoute({
  getParentRoute: () => grirMainRoute,
  id: 'grir-list-layout',
  component: ListViewWrapper,
});

const financeIndexRoute = createRoute({
  getParentRoute: () => financeMainRoute,
  path: '/',
  beforeLoad: () => redirect({ to: '/finance/invoices' }),
});

export const tasksMainRoute = createRoute({
  getParentRoute: () => financeMainRoute,
  path: 'tasks',
});

export const tasksListLayoutRoute = createRoute({
  getParentRoute: () => tasksMainRoute,
  id: 'tasks-list-layout',
  component: ListViewWrapper,
});

export const clawbackMainRoute = createRoute({
  getParentRoute: () => financeMainRoute,
  path: 'clawback',
});

export const clawbackListLayoutRoute = createRoute({
  getParentRoute: () => clawbackMainRoute,
  id: 'clawback-list-layout',
  component: ListViewWrapper,
});

export const financeRouteTree = financeMainRoute.addChildren({
  financeIndexRoute,
  invoicesMainRoute: invoicesMainRoute.addChildren({
    invoicesListLayoutRoute: invoicesListLayoutRoute.addChildren({
      inventoryInvoicesRoute,
    }),
    invoiceDetailsRoute,
    invoicesSettingsRoute,
  }),
  nonInventoryInvoicesMainRoute: nonInventoryInvoicesMainRoute.addChildren({
    nonInventoryListLayoutRoute: nonInventoryListLayoutRoute.addChildren({
      nonInventoryInvoicesRoute,
    }),
  }),
  grirMainRoute: grirMainRoute.addChildren({
    grirListLayoutRoute: grirListLayoutRoute.addChildren({
      grirListRoute,
    }),
    grirDetailRoute,
  }),
  clawbackMainRoute: clawbackMainRoute.addChildren({
    clawbackListLayoutRoute: clawbackListLayoutRoute.addChildren({
      clawbackListRoute,
    }),
    clawbackDetailRoute,
  }),
  tasksMainRoute: tasksMainRoute.addChildren({
    tasksListLayoutRoute: tasksListLayoutRoute.addChildren({
      tasksIndexRoute,
      tasksListRoute,
    }),
  }),
});
